import { useLangNavigate } from "../../hooks/useLangNavigate";
import { ReactComponent as BackIcon } from "../../assets/svg/category-back.svg";
import { useTranslation } from "react-i18next";
import styles from "./HeaderBack.module.css";

const HeaderBack = ({ url, title, onClick }) => {
  const navigate = useLangNavigate();
  const { i18n } = useTranslation();
  return (
    <div className={styles.header}>
      <div
        className={styles.headerIconContainer}
        onClick={() => {
          if (onClick) {
            onClick();
          } else if (url) {
            navigate(url);
          } else {
            navigate(-1);
          }
        }}
      >
        <BackIcon
          style={{
            rotate: i18n.dir() === "rtl" ? "180deg" : "0",
          }}
        />
      </div>
      <span className={styles.headerTitle}>{title}</span>
    </div>
  );
};

export default HeaderBack;